import { QoS } from 'async-mqtt';
import Transport from 'winston-transport';

import Communication from './communication';

interface ILogInfo {
  meta: object[];
  level: string;
  message: string;
  timestamp: string;
}

class MqttTransport extends Transport {
  private topic: string;

  constructor(opts: any = {}) {
    super(opts);
    const { topic = 'logs', level = 'info' } = opts;
    this.topic = topic;
    this.level = level || 'info';
  }

  public log = (info: ILogInfo, callback: Function) => {
    const message = { ...info, pid: process.pid };
    setImmediate(() => {
      this.emit('logged', message);
    });
    const qos: QoS = 2;
    Communication.systemPublish(this.topic, message, { qos, retain: false }).then(() => {
      try {
        callback(null, true);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }).catch((e: Error) => {
      // eslint-disable-next-line no-console
      console.error(e);
    });
  }
}

export default MqttTransport;
